module.exports = require("module");


//////////////////
// WEBPACK FOOTER
// external "module"
// module id = 105
// module chunks = 0 1